import React from 'react';
import dayjs from 'dayjs';
import { Avatar, Tooltip } from '@mantine/core';
import { ReactComponent as Pinicon } from 'assets/icons/pinIcon.svg';
import Popover from './Popover';
import DOMPurify from 'dompurify';
import moreicon from 'assets/icons/moreicon.svg';
const SingleMail = ({
  each: mail,
  selectedEmail,
  setSelectedEmail,
  useupdateMailStatus,
  setIsUpdated,
  searchTerm,
  today,
}) => {
  const handleClick = () => {
    setSelectedEmail(mail);

    if (!mail[0]?.is_read) {
      useupdateMailStatus.mutate({
        id: mail[0]?.id,
        read: true,
      });
    }
  };

  const renderToEmails = () => {
    return mail[0]?.to?.map((mail) => (
      <div key={mail}>
        <p>{mail?.email}</p>
      </div>
    ));
  };

  return (
    <div
      key={mail[0].id}
      className={` ${
        selectedEmail?.[0]?.id === mail[0]?.id ? ' bg-[#F8F8F8] ' : ''
      }  flex flex-col justify-start gap-x-2 my-2 2xl:my-3 3xl:my-4 p-4  cursor-pointer items-center border-[#fcdfdf] border-b`}
      onClick={handleClick}
    >
      <div className={` flex  items-start justify-between  w-full   `}>
        <div className='flex items-center  gap-x-2 '>
          <div className='relative'>
            <Avatar
              src={
                mail[0]?.mail_type === 'Draft' || mail[0]?.mail_type === 'Sent'
                  ? mail[0]?.to[0]?.profile_pic
                  : mail[0]?.from_addr[0]?.profile_pic
              }
              color='red'
              radius='xl'
              size={'36px'}
              classNames={{ root: 'border border-primary' }}
            >
              {mail[0]?.mail_type === 'Draft' || mail[0]?.mail_type === 'Sent'
                ? mail[0]?.to[0]?.name?.[0]?.toUpperCase()
                : mail[0]?.from_addr[0]?.name?.[0]?.toUpperCase()}
            </Avatar>
          </div>
          <Tooltip
            label={
              mail[0]?.mail_type === 'Draft' || mail[0]?.mail_type === 'Sent'
                ? renderToEmails()
                : mail[0]?.from_addr[0]?.email
            }
            classNames={{
              body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
            }}
            radius='md'
          >
            <h1
              className={`${
                mail[0]?.is_read ? '' : 'font-semibold'
              }  text-base   xl:text-md 2xl:text-xl 3xl:text-2xl`}
            >
              {mail[0]?.mail_type === 'Draft' || mail[0]?.mail_type === 'Sent'
                ? `To: ${mail[0]?.to[0]?.name?.substring(0, 12)}`
                : mail[0]?.from_addr[0]?.name?.substring(0, 12)}
            </h1>
          </Tooltip>
        </div>
        <div className='flex gap-x-2 items-center  self-center'>
          <Tooltip
            label={'Unpin'}
            classNames={{
              body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
            }}
            radius='md'
          >
            <Pinicon
              onClick={() =>
                useupdateMailStatus.mutate({
                  id: mail[0]?.id,
                  pin: false,
                })
              }
              className={`w-[0.8rem] cursor-pointer  ${
                mail[0]?.is_pinned ? 'block' : 'hidden'
              }`}
            />
          </Tooltip>

          <p className='text-838383 text-xs xl:text-xs 2xl:text-sm 3xl:text-lg'>
            {today
              ? dayjs(mail[0]?.created_time).format('hh:mm A')
              : dayjs(mail[0]?.created_time).format('ddd DD - MM')}
          </p>
          <Popover icon={moreicon} mail={mail[0]} setIsUpdated={setIsUpdated} />
        </div>
      </div>
      <div
        className={` ${mail[0]?.is_read ? '' : 'font-semibold'} w-full  flex `}
      >
        <div className='w-12'></div>
        <div className='w-full'>
          <div className='overflow-hidden max-h-12'>
            <div>
              <p className='text-2A2515'>
                {mail[0]?.subject ? mail[0]?.subject : '(No subject)'}
              </p>
            </div>
            <div
              className='text-justify'
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(mail[0]?.body),
              }}
            ></div>
          </div>
          {searchTerm && (
            <div className='w-full flex justify-end '>
              <p className='border px-1 text-838383 text-sm xl:text-xs 2xl:text-sm 3xl:text-lg'>
                {mail[0]?.mail_type}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleMail;
